import { render, staticRenderFns } from "./NavigationHomeIconParts.vue?vue&type=template&id=637c2492"
import script from "./NavigationHomeIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationHomeIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports